import React from 'react';

import LandingMenuItem from 'components/landing-menu-item';
import AmorcLogo from '../../../../../public/assets/images/amorc-logo.png';

/**
 * Components.
 */

/**
 * Style.
 */
import './header.scss';

const Header = ({ goTo }) => (
  <div className="header-wrapper">
    <img src={AmorcLogo} alt="" />
    <div className="phone">
      <LandingMenuItem onClick={() => goTo('sobre')}>SOBRE</LandingMenuItem>
      <LandingMenuItem onClick={() => goTo('beneficios')}>BENEFÍCIOS</LandingMenuItem>
      {/* </div> */}
      {/* <img src={AmorcLogo} alt="" /> */}
      {/* <div className="phone"> */}
      <LandingMenuItem>
        <a href="https://www.amorc.org.br/contribuicao-mensal/" rel="noopener noreferrer" target="_blank">
          CONTRIBUIÇÃO MENSAL
        </a>
      </LandingMenuItem>
      <LandingMenuItem onClick={() => goTo('comoFunciona')}>COMO FUNCIONA</LandingMenuItem>
      <LandingMenuItem onClick={() => goTo('AfiliarSe')}>AFILIE-SE</LandingMenuItem>
    </div>
  </div>
);

export default Header;
